<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
<!--        <span class="ivu-page-header-title">{{$route.meta.title}}</span>-->
<!--        <button label="发货订单" type="ghost" class="button_zi" icon="ios-arrow-back" @on-click="orderType(1)"> 发货订单</button>-->
<!--        <button label="自提订单"  type="ghost" class="button_zi" icon="ios-arrow-back" @on-click="orderType(2)">自提订单</button>-->
<!--        <Tag type="border" >发货订单</Tag>-->
<!--        <Tag type="border" @click.native="addDesignerTag(1)">自提订单</Tag>-->

        <Tabs v-model="userForm.order_type" @click.native="addDesignerTag()">
          <TabPane label="全部" name="0"></TabPane>
          <TabPane label="物流订单" name="1"></TabPane>

          <TabPane label="自提订单"  name="2"></TabPane>
          <TabPane label="配送订单"  name="3"></TabPane>
        </Tabs>

      </div>
    </div>

    <Card :bordered="false" dis-hover class="ivu-mt">



      <Form ref="userForm" :model="userForm"  :label-width="100" label-position="right" @submit.native.prevent>
        <Row type="flex" :gutter="12">
          <Col>
            <FormItem label="订单编号："  label-for="key">
              <Input  enter-button placeholder="请输入" v-model="userForm.key">
              </Input>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="核销码："  label-for="key" v-if="userForm.order_type == 2">
              <Input  enter-button placeholder="请输入" v-model="userForm.key">
              </Input>
            </FormItem>
          </Col>
          <Col>
          <FormItem label="订单状态："  label-for="key" >
            <Select v-model="userForm.status" style="width:200px;float:left" >
              <Option  value="-1" >全部</Option>
              <Option  value="0" >待支付</Option>
              <Option  value="1" >待发货</Option>
              <Option  value="2" >待收货</Option>
              <Option  value="3" >待评价</Option>
              <Option  value="4" >已完成</Option>
              <Option  value="5" >已取消</Option>
            </Select>
          </FormItem>
          </Col>

          <Col>
            <Button type="primary" shape="circle" icon="ios-search"  @click="userSearchs()">搜索</Button>
          </Col>
        </Row>

      </Form>
      <Table :columns="columns2" :data="userInfo" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
      >

        <template slot-scope="{ row, index }" slot="order_type">
          <div v-if="row.order_type ==1"><Tag color ="success">{{row.order_type_name}}</Tag></div>
          <div v-if="row.order_type ==2"><Tag color="error">{{row.order_type_name}}</Tag></div>
          <div v-if="row.order_type ==3"><Tag color="warning">{{row.order_type_name}}</Tag></div>

        </template>

        <template slot-scope="{ row, index }" slot="pay_type">
          <div v-if="row.pay_type ==1"><Tag color="success">微信</Tag></div>
          <div v-if="row.pay_type ==2"><Tag color="error">支付宝</Tag></div>
          <div v-if="row.pay_type ==3"><Tag >余额</Tag></div>

        </template>

        <template slot-scope="{ row, index }" slot="status">
         <div v-if="row.status ==0"><Tag  color="success">待支付</Tag ></div>
         <div v-if="row.status ==1"><Tag >待发货</Tag></div>
         <div v-if="row.status ==2"><Tag color="warning">待收货</Tag></div>
         <div v-if="row.status ==3"><Tag color="dashed">待评价</Tag></div>
         <div v-if="row.status ==4"><Tag >已完成</Tag></div>
         <div v-if="row.status ==5"><Tag color="error">已取消</Tag></div>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <a v-if="row.order_type ==2 && row.status==2" @click="ziti(row.id)">订单核销</a>
          <Divider type="vertical" v-if="row.order_type ==2 && row.status==2"/>
          <a @click="edit(row.id)">编辑</a>
<!--          <Divider type="vertical" />-->
<!--          <a @click="del(row.id)">删除</a>-->
        </template>
      </Table>
      <Page :total="dataCount" :current="userForm.page" :page-size="userForm.limit" class="acea-row row-right page" show-total  @on-change="changepage"></Page>
    </Card>
    <!--删除-->
    <modalSure ref="modalSure" title="订单" :confirm="confirm" :id="order_id" :modelApi="modelApi" @closeModal="closeModal"></modalSure>
  </div>
</template>
<style>
  .button_zi{
    width: 100px;
    line-height: 50px;
    border: 1px;
    border-radius: 10px;
    margin-left: 5px;
  }
</style>
<script>

import { list,dels,ziti} from '@/api/goodsOrder'
import modalSure from '@/components/modalSure'
export default {
  name: 'index',
  components: { modalSure },
  inject: ['reload'],
  data () {
    return {
      userForm: {
        page: 1,
        limit: 10,
        key: '',
        status: -1,
        order_type: '',
      },
      order_id: 0,
      modelApi: dels,
      confirm: false,

      dataCount: 0,
      userInfo: [],
      loading: false,
      columns2: [

        {
          title: '订单编号',
          key: 'order_sn',
          align: 'center',
          minWidth: 200
        },
        {
          title: '所属门店',
          key: 'shop_name',
          align: 'center',
          minWidth: 180
        },
        {
          title: '用户呢称',
          key: 'nickname',
          align: 'center',
          minWidth: 120
        },
        {
          title: '订单类型',
          slot: 'order_type',
          align: 'center',
          minWidth: 120
        },
        {
          title: '支付方式',
          slot: 'pay_type',
          align: 'center',
          minWidth: 120
        },
        {
          title: '订单状态',
          slot: 'status',
          align: 'center',
          minWidth: 120
        },
        {
          title: '收货人姓名',
          key: 'receiver_name',
          align: 'center',
          minWidth: 120
        },
        {
          title: '收货人电话',
          key: 'receiver_phone',
          align: 'center',
          minWidth: 120
        },
        {
          title: '订单总金额',
          key: 'total_fee',
          align: 'center',
          minWidth: 120
        },
        {
          title: '骑手',
          key: 'rider_name',
          align: 'center',
          minWidth: 120
        },
        // {
        //   title: '优惠金额',
        //   key: 'preferential_price',
        //   minWidth: 120
        // },
        // {
        //   title: '总价',
        //   key: 'original_fee',
        //   minWidth: 120
        // },
        {
          title: '下单时间',
          key: 'ctime',
          align: 'center',
          minWidth: 120
        },
        {
          title: '操作',
          slot: 'action',
          fixed: 'right',
          minWidth: 160
        }
      ]
    }
  },
  created () {
    this.bannerList()
  },
  activated () {
    this.bannerList()
  },
  methods: {
    bannerList() {
      this.loading = true
      list(this.userForm).then(res => {

        this.userInfo = res.data.list
        this.dataCount = res.data.count
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },
    // 表格搜索
    userSearchs () {
      this.userForm.page = 1
      this.bannerList()
    },
    selectChange () {
      this.userForm.key = ''
    },
    edit (id) {

      this.$router.push({ path: '/admin/order/order/edit/' + id })
    },
    ziti (id) {
      let data = {
        'id': id,
      }
      ziti(data).then(res => {
        let msg = '订单核销成功'

        if (res.code === 200) {
          this.$Message.success(msg)
          this.bannerList()
        } else {
          this.$Message.error(res.msg)
        }
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },

    orderType (row) {
     console.log(1111)
     console.log(this.userForm.order_type)
    },
    del (row) {
      this.order_id = row
      // this.confirm = true
      this.$refs.modalSure.isShow = true
    },
    closeModal (val) {
      if (val) {
        this.reload()
      }
    },
    updateStatusModel (modalStatus) {
      this.reload()
    },
    addDesignerTag(type){
      console.log(this.userForm.order_type)
      this.bannerList()
    },

    // 分页
    changepage (status) {
      this.userForm.page = status
      this.bannerList()
    },

  }
}
</script>
